import styled from 'styled-components'

import { Layout, Text } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import type { TrackingProvider } from '../../../domain/Tracking'
import { formatTrackingProviderName } from '../../../presenters/preferredTrackingMethod'
import ImageTruckerTools from '../../assets/tracking-onboarding-finalize-connection-tt.png'
import { useTrackingOnboardingContext } from './TrackingOnboardingContext'

const StyledListItem = styled.li`
  padding-bottom: ${getToken('spacing-2')};
  list-style: decimal;
`

export type ELDFinalizeConnectionContentProps = {
  readonly selectedProvider?: TrackingProvider
}

export default function ELDFinalizeConnectionContent({
  selectedProvider,
}: ELDFinalizeConnectionContentProps) {
  const { hasPreviousTracking } = useTrackingOnboardingContext()

  if (hasPreviousTracking) {
    const formatterName = formatTrackingProviderName(selectedProvider)

    return (
      <Layout.Group style={{ flexWrap: 'nowrap' }} gap="spacing-12">
        <Layout.Stack gap="spacing-4">
          <Text variant="body-md-bold">ELD with {formatterName}</Text>

          <Layout.Stack gap="spacing-6">
            <Text variant="body-md">
              You're about to confirm your preferred connection as {formatterName} ELD.
            </Text>
            <Text variant="body-md">You can update this choice anytime via the tracking card.</Text>
          </Layout.Stack>
        </Layout.Stack>
        <img src={ImageTruckerTools} alt="Trucker Tools" width={220} height={250} />
      </Layout.Group>
    )
  }

  return (
    <Layout.Group style={{ flexWrap: 'nowrap' }} gap="spacing-12">
      <Layout.Stack gap="spacing-4">
        <Text variant="body-md-bold">Connect to Trucker Tools ELDs</Text>
        <Text variant="body-md">
          When you connect with your telematics account, a single integration enables you to
          seamlessly send location data from your GPS devices, use the Trucker Tools setup to
          complete it and get it ready to track your loads.
        </Text>
        <Layout.Group paddingL="spacing-4">
          <Text variant="body-md">
            <ol>
              <StyledListItem>
                You will be redirected to Trucker Tools ELD setup page
              </StyledListItem>
              <StyledListItem>
                Enter your information and submit the connection request
              </StyledListItem>
              <StyledListItem>
                After submitting the request, someone from Trucker Tools will reach out to you and
                complete the connection.
              </StyledListItem>
            </ol>
          </Text>
        </Layout.Group>
      </Layout.Stack>
      <img src={ImageTruckerTools} alt="Trucker Tools" width={220} height={250} />
    </Layout.Group>
  )
}
